import application_settings from '../applicationSettings';
import Event from './Event';


class GetCmsPageContent extends Event {
    eventName = 'oms_getCmsPageContent';
    
    constructor() {
        super();
        this.add();
    }

    /**
     * Event function for getting CMS page content
     * @param {object} data - Object containing client_id and url_key
     * @param {string} data.client_id - The client ID
     * @param {string} data.url_key - The URL key for the CMS page
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let urlKey = data.url_key;
        let requestId = data.request_id || '';
        let action = data.action || '';
        let thisObj = this; 
        
        // request data
        data.endPoint = application_settings.endPoints.getCmsPageContent;
        data.data = {
            url_key: urlKey,
            client_id: clientId,
        };
    
        this.sendRequest(data, function (response) {
            if (response) {
                
                let data = thisObj.formatResponseData(response);
                thisObj.onSuccessEvent(data, {
                    'action' : action, 
                    'request_id' : requestId, 
                });
            }
        });
        
    }
}

export default GetCmsPageContent;
